/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Ai_1Inputs */

const da_privacy_ai_1 = /** @type {(inputs: Privacy_Ai_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Når du beder om en rettelse, sender vi sider fra den anonymiserede besvarelse sammen med opgavesæt og rettevejledning til en AI-sprogmodel hos en udbyder i EU. Modellen får hverken dine kontooplysninger eller elevernes navne.`)
};

/** @type {(inputs: Privacy_Ai_1Inputs) => LocalizedString} */
const en_privacy_ai_1 = da_privacy_ai_1;

/**

* @param {Privacy_Ai_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_ai_1 = /** @type {((inputs?: Privacy_Ai_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Ai_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_ai_1(inputs)
	return /** @type {LocalizedString} */ ("Når du beder om en rettelse, sender vi sider fra den anonymiserede besvarelse sammen med opgavesæt og rettevejledning til en AI-sprogmodel hos en udbyder i EU. Modellen får hverken dine kontooplysninger eller elevernes navne.")
});